<template>
  <ag-card-container centered :title="$t('menu.mycompany')">
    <my-company-form
      v-if="company"
      :value="value"
      :loading="loading"
      @input="onInput"
    />
  </ag-card-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AgCardContainer from 'src/components/common/AgCardContainer'
import MyCompanyForm from '../components/MyCompanyForm'

export default {
  name: 'MyCompanyContainer',
  components: {
    AgCardContainer,
    MyCompanyForm,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters('me', {
      company: 'company',
    }),
    value () {
      return {
        ...this.company,
        companyContact: this.company?.companyContact?.id ?? null,
      }
    },
  },
  methods: {
    ...mapActions('me', {
      updateMyCompany: 'updateMyCompany',
    }),
    async onInput ({ masterContactList, logo, ...company }) {
      this.loading = true
      await this.updateMyCompany({
        ...company,
        ...(logo ? { logo } : {}),
      })
      this.loading = false
    },
  },
}
</script>
